export type TrustpilotHomepageWidgetConfig = Record<string, string>

export const CONTROL_WIDGET_CONFIG: TrustpilotHomepageWidgetConfig = {
  'data-template-id': '5406e65db0d04a09e042d5fc',
  'data-style-height': '28px',
  'data-style-width': '100%',
}

export const MICRO_STAR_WIDGET_CONFIG: TrustpilotHomepageWidgetConfig = {
  'data-template-id': '5419b732fbfb950b10de65e5',
  'data-style-height': '24px',
  'data-style-width': '100%',
  'data-token': 'f0eefe0a-f58d-40c0-8c3b-6b830da071a7',
  'data-text-color': '#00204d',
}
